export default "__VITE_ASSET__BPP__OM6__"